const actionTypes = {
  AUTHENTICATE: "USER_AUTHENTICATE",
  AUTHENTICATE_ERROR: "USER_AUTHENTICATE_ERROR",
  AUTHENTICATE_SUCCESS: "USER_AUTHENTICATE_SUCCESS",
  LOGOUT: "USER_LOGOUT",
  LOGOUT_SUCCESS: "USER_LOGOUT_SUCCESS",
  STORE_ACCESS_TOKEN: "USER_STORE_ACCESS_TOKEN",
  STORE_IS_LOADING: "USER_STORE_IS_LOADING",
  UPDATE_ACCESS_TOKEN: "UPDATE_ACCESS_TOKEN",
};

export default actionTypes;
